export enum Roles {
  Admin = "admin",
  Supervisor = "supervisor",
  PropertyManager = "propManager",
  Client = "client",
}
import {
  getViewer_viewer as ViewerInterface,
  getViewer_viewer_lists_scheduledUpdate as ScheduledUpdateInterface,
} from "types/gql-types";

// Hack due to fact that interfaces can't be reexported
export type Viewer = ViewerInterface & {};
export type ScheduledUpdate = ScheduledUpdateInterface & {};
